import DemandeLivraisonFormController from './demande.livraison.form.controller';

export default {
    template: require('./demande.livraison.form.html'),
    controller: DemandeLivraisonFormController
};
